<template>
    <div class="bg-surface-secondary w-100">
        <modal-masive :onmasive="onmasive" :count="count_masive" @onclose="onmasive = false" @onmasive="MASIVE()"/>
        <header class="bg-surface-primary border-bottom">
            <div class="container-fluid py-3">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="d-flex align-items-center gap-4">
                            <div>
                                <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                            </div>
                            <div class="vr opacity-20 my-1"></div>
                            <div>
                                <h1 class="h4 ls-tight">Escaneo</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid vstack gap-5">
                <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                    <div class="d-flex gap-3 row">
                        <div class="col-md-4 px-0">
                            <div class="input-group input-group-sm input-group-inline">
                                <div class="input-group-prepend">
                                    <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                </div>
                                <search v-model="awb" autofocus item-text="awb" item-value="awb" childplaceholder="Seleccione o ingrese un AWB..." endpoint="/close/awbs"/>
                            </div>
                        </div>
                        <div>
                            <button type="button" :disabled="!awb" @click="FILTER()" class="btn btn-h px-3 btn-primary">
                                <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'filter'">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span v-else>Filtrar</span>
                            </button>
                        </div>
                        <div>
                            <button type="button" :disabled="!awb" @click="CLEAR()" class="btn btn-h px-3 btn-danger">
                                <span>Limpiar</span>
                            </button>
                        </div>
                        <div class="mr-0 ml-auto" v-if="scan == true">
                            <button type="button" :disabled="data.packages.length == 0 && data.hawbs.filter((e) => e.packages.length > 0 ).length == 0" class="btn btn-h px-3 btn-success" @click="MASIVE_VALIDATE()">
                                <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'masive'">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span v-else>
                                    <i class="bi bi-arrow-clockwise"></i> Facturación masiva
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center gap-3">
                    <div class="mb-1 d-flex gap-2 align-items-center">
                        <div class="cuadre-color border bg-white"></div><small>: Sin escanear</small>
                    </div>
                    <div class="mb-1 d-flex gap-2 align-items-center">
                        <div class="cuadre-color yellow"></div><small>: Escaneado</small>
                    </div>
                    <div class="mb-1 d-flex gap-2 align-items-center">
                        <div class="cuadre-color bg-secondary"></div><small>: En proceso</small>
                    </div>
                    <div class="mb-1 d-flex gap-2 align-items-center">
                        <div class="cuadre-color bg-primary"></div><small>: Facturación masiva</small>
                    </div>
                </div>
                <div class="w-100 py-3" v-if="scan == false">
                    <p class="text-sm text-muted text-left mb-0" v-if="scan == false && loading == ''">Seleccione o ingrese un AWB para empezar a escanear.</p>
                </div>
                <div class="card" v-else>
                    <div class="card-header bg-white">
                        <h5 class="me-auto">Escaneo</h5>
                    </div>
                    <div class="card-body">
                        <div v-if="scan == true && data.packages.length > 0 || scan == true && data.hawbs.length > 0">
                            <form @submit.prevent="CHECK()" class="d-flex gap-3 row">
                                <div class="col-lg-11 col-sm-10 col-9 px-0">
                                    <div class="input-group input-group-inline">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text pe-2 text-sm">GV</span>
                                        </div>
                                        <input type="text" class="form-control" :readonly="loading == 'destination'" placeholder="Buscar..." ref="number" v-model="number">
                                    </div>
                                </div>
                                <div>
                                    <button type="submit" :disabled="!number" class="btn px-3 btn-primary">
                                        <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'destination'">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <span v-else>Buscar</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p class="text-sm text-muted text-center mb-0" v-else>No hay resultados.</p>
                    </div>
                </div>
                <table-scan :data="data.packages" v-if="data.packages.length > 0" :title="data.awb"></table-scan>
                <div v-for="(item, index) in data.hawbs" :key="index">
                    <table-scan :data="item.packages" :title="item.hawb"></table-scan>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import TableScan from './table/TableScan'
import ModalMasive from './modals/Masive'
export default {
    components: { TableScan, ModalMasive },
    data() {
        return {
            loading: '',
            scan: false,
            data: {
                packages: [],
                hawbs: []
            },
            awb: '',
            number: '',
            count: 0,
            destination: 0,
            masive: 0,
            count_masive: 0,
            onmasive: false,
        }
    },
    mounted() {
        let vue = this
        Echo.channel('masive')
            .listen('MasiveEvent', (e) => {
                let index = vue.data.packages.findIndex(a => a.id == e.id)
                if(index != -1){
                    vue.data.packages[index].job = e.job
                    vue.data.packages[index].state_id = e.state_id
                    vue.data.packages[index].masived_at = e.masived_at
                }else{
                    vue.data.hawbs.forEach(element => {
                        index = element.packages.findIndex(a => a.id == e.id)
                        if(index != -1){
                            element.packages[index].job = e.job
                            element.packages[index].state_id = e.state_id
                            element.packages[index].masived_at = e.masived_at
                        }
                    })
                }
            })
    },
    methods: {
        CLEAR: function(awb = true){
            let vue = this
            vue.data = {
                packages: [],
                hawbs: [],
            }
            if(awb){
                vue.awb = ''
            }
            vue.scan = false
            vue.onmasive = false
        },
        FILTER: function(){
            let vue = this
            vue.CLEAR(false)
            vue.count++
            vue.loading = 'filter'
            if (vue.count == 1) {
                axios({ url: '/awbs/'+vue.awb, method: 'GET' })
                    .then((resp) => {
                        vue.data = resp.data
                        vue.scan = true
                    })
                    .catch((err) => {
                        if (err.response.status === 402 || err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                        vue.loading = ''
                        vue.$nextTick(() => vue.$refs.number.focus())
                    })
            }
        },
        CHECK: function(){
            let vue = this
            vue.destination++
            vue.loading = 'destination'
            if (vue.destination == 1) {
                let data = {
                    id: vue.number,
                    awb_id: vue.data.id
                }
                axios({ url: '/destination/packages/save', method: 'POST', data: data })
                    .then((resp) => {
                        var audio = new Audio(soundSuccess)
                        audio.play()
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.number = ''
                        let index = vue.data.packages.findIndex(a => a.id == resp.data.data.id)
                        if(index != -1){
                            vue.data.packages[index].state_id = 4
                        }else{
                            vue.data.hawbs.forEach(element => {
                                index = element.packages.findIndex(a => a.id == resp.data.data.id)
                                if(index != -1){
                                    element.packages[index].state_id = 4
                                }
                            })
                        }
                    })
                    .catch((err) => {
                        var audio = new Audio(soundError)
                        audio.play()
                        if (err.response.status === 402 || err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.destination = 0
                        vue.loading = ''
                        vue.$nextTick(() => vue.$refs.number.focus())
                    })
            }
        },
        MASIVE_VALIDATE: function(){
            let vue = this
            vue.masive++
            vue.loading = 'masive'
            if (vue.masive == 1) {
                axios({ url: '/masive/billing/'+vue.awb+'/validate', method: 'GET' })
                .then((resp) => {
                    vue.MASIVE()
                })
                .catch((err) => {
                    if (err.response.status === 404) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else if(err.response.status === 402){
                        vue.onmasive = true
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.masive = 0
                    vue.loading = ''
                    vue.$nextTick(() => vue.$refs.number.focus())
                })
            }
        },
        MASIVE: function(){
            let vue = this
            vue.count_masive++
            if (vue.count_masive == 1) {
                axios({ url: '/masive/billing/'+vue.awb, method: 'GET' })
                .then((resp) => {
                    vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .catch((err) => {
                    if (err.response.status === 402 || err.response.status === 404) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.count_masive = 0
                    vue.masive = 0
                    vue.loading = ''
                    vue.onmasive = false
                    vue.$nextTick(() => vue.$refs.number.focus())
                })
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/awbs/Scan.vue